import axios from "axios";

export default axios.create({
  baseURL: "https://hrms-backend-afbb.onrender.com"
});
